/**
 * Filtros del listado de Socios en la URL (auditoría UX-07): buscar, abrir
 * una cuenta corriente y volver conserva la consulta, los filtros y la
 * página, y la URL compartida reproduce el listado.
 *
 *   /socios?q=perez&condicion=clientes&estado=todos&pagina=3
 *
 * Los valores por defecto no se escriben, para que /socios quede limpio.
 */
import type { CondicionFiltro, EstadoFiltro } from "./api";

export const TAMANO_PAGINA = 50;

export interface FiltrosSocios {
  q: string;
  condicion: CondicionFiltro;
  estado: EstadoFiltro;
  /** 1-based. */
  pagina: number;
}

const CONDICIONES: readonly CondicionFiltro[] = ["todos", "socios", "clientes"];
const ESTADOS: readonly EstadoFiltro[] = ["activos", "Inactivo", "Fallecido", "todos"];

export function leerFiltros(params: URLSearchParams): FiltrosSocios {
  const condicion = params.get("condicion");
  const estado = params.get("estado");
  const pagina = Number(params.get("pagina"));
  return {
    q: params.get("q") ?? "",
    condicion: CONDICIONES.find((c) => c === condicion) ?? "todos",
    estado: ESTADOS.find((e) => e === estado) ?? "activos",
    pagina: Number.isInteger(pagina) && pagina > 0 ? pagina : 1,
  };
}

export function escribirFiltros(f: FiltrosSocios): URLSearchParams {
  const params = new URLSearchParams();
  if (f.q.trim()) params.set("q", f.q.trim());
  if (f.condicion !== "todos") params.set("condicion", f.condicion);
  if (f.estado !== "activos") params.set("estado", f.estado);
  if (f.pagina > 1) params.set("pagina", String(f.pagina));
  return params;
}

/** "Mostrando 51–100 de 2.025". */
export function rangoMostrado(pagina: number, total: number, enPagina: number): string {
  if (total === 0) return "Sin resultados";
  const desde = (pagina - 1) * TAMANO_PAGINA + 1;
  const hasta = desde + enPagina - 1;
  const fmt = (n: number): string => n.toLocaleString("es-CL");
  return `Mostrando ${fmt(desde)}–${fmt(hasta)} de ${fmt(total)}`;
}

export function totalPaginas(total: number): number {
  return Math.max(1, Math.ceil(total / TAMANO_PAGINA));
}
